import { FeiVO } from '../../../vo/workingdata/fei.vo';
import { Model } from '../../../model/model';
import { DATA_KIND } from '../../../model/enums';
import { FunctionObj } from '../../../vo/workingdata/function-obj';
import { FunctionCoreEngine } from '../function.core.engine';
import { MeasModeItem } from '../measure.mode.obj';

/**
 * fonctions math
 */
export class MathFunctions {

  public static readonly FLOOR: string = 'FLOOR'; // plancher
  public static readonly CEIL: string = 'CEIL'; // plafond

  public static functions(model: Model): FunctionObj[] {
      const funcArr: FunctionObj[] = [];
      /** arrondi au plus proche Param 1: nombre cible, Param 2: nb décimales */
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'ROUND', [DATA_KIND.NUMBER, DATA_KIND.NUMBER]));
      /** arrondi à l'entier supérieur Param 1: nombre cible */
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'ROUNDUP', [DATA_KIND.NUMBER]));
      /** arrondi à l'entier inférieur Param 1: nombre cible */
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'ROUNDDOWN', [DATA_KIND.NUMBER]));

      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'SUM', [DATA_KIND.NUMBER], true));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'ABS', [DATA_KIND.NUMBER], true));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'AVG', [DATA_KIND.NUMBER], true));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'MAX', [DATA_KIND.NUMBER], true));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'MIN', [DATA_KIND.NUMBER], true));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'POW', [DATA_KIND.NUMBER, DATA_KIND.NUMBER]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'COUNT', [DATA_KIND.STRING], true));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'COUNTDISTINCT', [DATA_KIND.STRING], true));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'RANDOM', [DATA_KIND.NUMBER]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'SIN', [DATA_KIND.NUMBER]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'COS', [DATA_KIND.NUMBER]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'TAN', [DATA_KIND.NUMBER]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'LOG', [DATA_KIND.NUMBER]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'EXP', [DATA_KIND.NUMBER]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'PI', [DATA_KIND.NUMBER]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'E', [DATA_KIND.NUMBER]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'SQRT', [DATA_KIND.NUMBER]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'DIVIDE', [DATA_KIND.NUMBER, DATA_KIND.NUMBER]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'ENUMERATE', [DATA_KIND.STRING]));
      funcArr.push(new FunctionObj(model, FunctionObj.KIND_MATH, 'GPSDIST', [DATA_KIND.NUMBER, DATA_KIND.NUMBER, DATA_KIND.NUMBER, DATA_KIND.NUMBER]));
      return funcArr;
  }


  /**
   * absolu
   * @param mmi Etape de calcul concernée
   */
  public static ABS(mmi: MeasModeItem): void {
    const param1: MeasModeItem = mmi.c[0]; // mesure
    // contrôle de cohérence
    if (param1.isErr) {
      mmi.r = param1.r;
      mmi.isErr = true;
    } else {
      const val: number = Number(param1.r);
      mmi.r = Math.abs(val).toString();
    }
  }


  /**
   * Arrondi le param1 au niveau de précision du param2
   * @param mmi Etape de calcul concernée
   * @param way: null, FLOOR ou CEIL
   */
    public static ROUND(mmi: MeasModeItem, way: string = null): void {
      const param1: MeasModeItem = mmi.c[0]; // valeurs
      const param2: MeasModeItem = mmi.c[1]; // la précision

      // contrôle de cohérence
      if (param1.isErr) {
        mmi.r = param1.r;
        mmi.isErr = true;
      } else {
        const val: number = Number(param1.r);
        const precision: number = param2 ? Number(param2.r) : 0;
        if (way === this.FLOOR) {
          mmi.r = Math.floor(val).toString();
        } else if (way === this.CEIL) {
          mmi.r = Math.ceil(val).toString();
        } else {
          mmi.r = val.toFixed(precision);
        }
      }
    }

  /**
   * fait la somme des contents : x params
   *
   * @param mmi Etape de calcul concernée
   * @param fixedMmi pour calcul sans consolidation (déjà fait par une série)
   */
  public static SUM(mmi: MeasModeItem, fixedMmi: string[], fei: FeiVO): number {
    let sumResult: number = null;
    if (!fixedMmi) {
      fixedMmi = FunctionCoreEngine.collectToMmiContent(fei.model, mmi);
    }
    fixedMmi?.forEach((str: string) => {
      // on va faire la somme des valables
      if (!sumResult) {
        sumResult = 0;
      }
      sumResult = sumResult + Number(str);
    });
    mmi.r = sumResult?.toString();
    return sumResult;
  }

  /**
   * compte le nombre d'éléments (tous, même les vides)
   * @param mmi Etape de calcul concernée
   * @param fixedMmi pour calcul sans consolidation (déjà fait par une série)
   */
  public static ENUMERATE(mmi: MeasModeItem, fixedMmi: string[], fei: FeiVO): number {
    let cpt: number = 0;
    if (!fixedMmi) {
      fixedMmi = FunctionCoreEngine.collectToMmiContent(fei.model, mmi);
    }
    cpt = fixedMmi?.length || 0;
    mmi.r = cpt.toString();
    return cpt;
  }

  /**
   * compte le nombre d'éléments
   * @param mmi Etape de calcul concernée
   * @param fixedMmi pour calcul sans consolidation (déjà fait par une série)
   */
  public static COUNT(mmi: MeasModeItem, fixedMmi: string[], fei: FeiVO): number {
    let cpt: number = 0;
    if (!fixedMmi) {
      fixedMmi = FunctionCoreEngine.collectToMmiContent(fei.model, mmi);
    }
    fixedMmi?.forEach((str: string) => {
      // on va faire le compte des valables
      if (!!str) {
        cpt++;
      }
    });
    mmi.r = cpt.toString();
    return cpt;
  }

  /**
   * fait la moyenne des contents
   *
   * @param mmi Etape de calcul concernée
   * @param fixedMmi pour calcul sans consolidation (déjà fait par une série)
   */
  public static AVG(mmi: MeasModeItem, fixedMmi: string[], fei: FeiVO): void {
    let result: number = 0;

    const divider: number = this.COUNT(mmi, fixedMmi, fei);
    const divided: number = this.SUM(mmi, fixedMmi, fei);
    // Si la somme s'est bien passée, on peut opérer la division ou pas ...
    if (!mmi.isErr) {
      if (divider > 0) {
        result = Math.round((divided * 100000) / divider) / 100000;
      }
      mmi.r = result.toString();
    }
  }

  /**
   * retourne le max
   *
   * @param mmi Etape de calcul concernée
   * @param fixedMmi pour calcul sans consolidation (déjà fait par une série)
   */
  public static MAX(mmi: MeasModeItem, fixedMmi: string[], fei: FeiVO): void {
    this.getExtremum(mmi, true, fixedMmi, fei);
  }

  /**
   * retourne le min
   *
   * @param mmi Etape de calcul concernée
   * @param fixedMmi pour calcul sans consolidation (déjà fait par une série)
   */
  public static MIN(mmi: MeasModeItem, fixedMmi: string[], fei: FeiVO): void {
    this.getExtremum(mmi, false, fixedMmi, fei);
  }

  /**
   * Retourne le min ou le max
   *
   * @param mmi      Etape de calcul concernée
   * @param maxValue True si on veut le max, False si on veut le min
   */
  private static getExtremum(mmi: MeasModeItem, maxValue: boolean, fixedMmi: string[], fei: FeiVO): void {
    let result: number = null;

    // contrôle de la collection
    if (!fixedMmi) {
      fixedMmi = FunctionCoreEngine.collectToMmiContent(fei.model, mmi);
    }
    fixedMmi?.forEach((str: string) => {
      result = this.getNewExtremum(result, str, maxValue);
    });
    mmi.r = result?.toString();
  }

  /**
   * Retourne l'extremum entre deux valeurs
   * Si la valeur de comparaison est nulle, la valeur à comparer
   * devient le nouvel extremum
   *
   * @param a        Valeur de comparaison
   * @param b        Valeur à comparer
   * @param maxValue True si on veut le max, False si on veut le min
   * @return BigDecimal L'extremum déterminé
   */
  private static getNewExtremum(a: number, b: string, maxValue: boolean): number {
    let result: number = a;
    const newVal: number = Number(b);

    if (result == null) {
      result = newVal;
    } else {
      if (maxValue) {
        if (newVal > result) {
          result = newVal;
        }
      } else {
        if (newVal < result) {
          result = newVal;
        }
      }
    }
    return result;
  }

  /**
   * fonction puissance
   *
   * @param mmi Etape de calcul concernée
   */
  public static POW(mmi: MeasModeItem): void {
    const param1: MeasModeItem = mmi.c[0]; // valeurs
    const param2: MeasModeItem = mmi.c[1]; // puissance

    // contrôle de cohérence
    if (param1.isErr || param2.isErr) {
      mmi.r = param1.r;
      mmi.isErr = true;
    } else {
      const val: number = Number(param1.r);
      const pow: number = Number(param2.r);
      mmi.r = Math.pow(val, pow).toString();
    }
  }

  /**
   * compte le nbr de valeurs distinctes, non nulles
   * @param mmi Etape de calcul concernée
   * @param fixedMmi pour calcul sans consolidation (déjà fait par une série)
   */
  public static COUNTDISTINCT(mmi: MeasModeItem, fixedMmi: string[], fei: FeiVO): number {

    const result: Set<string> = new Set();
    if (!fixedMmi) {
      fixedMmi = FunctionCoreEngine.collectToMmiContent(fei.model, mmi);
    }
    fixedMmi?.forEach((str: string) => {
      if (!!str) {
        result.add(str); // TODO pas les nulls ? les vides ??
      }
    });
    mmi.r = result.size.toString();
    return result.size;
  }

  /**
   * Random
   * @param mmi Etape de calcul concernée
   */
  public static RANDOM(mmi: MeasModeItem): void {
    const param1: MeasModeItem = mmi.c[0]; // valeurs
    let mult: number = 1;
    // contrôle de cohérence
    if (!!param1.r) {
      mult = Number(param1.r);
    }

    const res = Math.random() * mult;
    mmi.r = res.toString();
  }

  /**
   * cosinus
   * @param mmi Etape de calcul concernée
   */
  public static COS(mmi: MeasModeItem): void {
    const param1: MeasModeItem = mmi.c[0]; // mesure
    // contrôle de cohérence
    if (param1.isErr) {
      mmi.r = param1.r;
      mmi.isErr = true;
    } else {
      const val: number = Number(param1.r);
      mmi.r = Math.cos(val).toString();
    }
  }

  /**
   * sinus
   * @param mmi Etape de calcul concernée
   */
  public static SIN(mmi: MeasModeItem): void {
    const param1: MeasModeItem = mmi.c[0]; // mesure
    // contrôle de cohérence
    if (param1.isErr) {
      mmi.r = param1.r;
      mmi.isErr = true;
    } else {
      const val: number = Number(param1.r);
      mmi.r = Math.sin(val).toString();
    }
  }

  /**
   * tangente
   * @param mmi Etape de calcul concernée
   */
  public static TAN(mmi: MeasModeItem): void {
    const param1: MeasModeItem = mmi.c[0]; // mesure
    // contrôle de cohérence
    if (param1.isErr) {
      mmi.r = param1.r;
      mmi.isErr = true;
    } else {
      const val: number = Number(param1.r);
      mmi.r = Math.cos(val).toString();
    }
  }

  /**
   * logarithme
   * @param mmi Etape de calcul concernée
   */
  public static LOG(mmi: MeasModeItem): void {
    const param1: MeasModeItem = mmi.c[0]; // mesure
    // contrôle de cohérence
    if (param1.isErr) {
      mmi.r = param1.r;
      mmi.isErr = true;
    } else {
      const val: number = Number(param1.r);
      mmi.r = Math.log10(val).toString();
    }
  }

  /**
   * exponentiel
   * @param mmi Etape de calcul concernée
   */
  public static EXP(mmi: MeasModeItem): void {
    const param1: MeasModeItem = mmi.c[0]; // mesure
    // contrôle de cohérence
    if (param1.isErr) {
      mmi.r = param1.r;
      mmi.isErr = true;
    } else {
      const val: number = Number(param1.r);
      mmi.r = Math.exp(val).toString();
    }
  }

  /**
   * racine carrée
   * @param mmi Etape de calcul concernée
   */
  public static SQRT(mmi: MeasModeItem): void {
    const param1: MeasModeItem = mmi.c[0]; // mesure
    // contrôle de cohérence
    if (param1.isErr) {
      mmi.r = param1.r;
      mmi.isErr = true;
    } else {
      const val: number = Number(param1.r);
      if (val <= 0) {
        mmi.r = null;
        mmi.isErr = true;
      } else {
        mmi.isErr = false;
        mmi.r = Math.sqrt(val).toString();
      }
    }
  }

  /**
   * pi
   * @param mmi Etape de calcul concernée
   */
  public static PI(mmi: MeasModeItem): void {
    const param1: MeasModeItem = mmi.c[0]; // mesure
    mmi.r = Math.PI.toString();
  }

  /**
   * E
   * @param mmi Etape de calcul concernée
   */
   public static E(mmi: MeasModeItem): void {
    const param1: MeasModeItem = mmi.c[0]; // mesure
    mmi.r = Math.E.toString();
  }

  /**
   * divise le premier nombre par le deuxième, renvoi 0 si le diviseur est nul
   * @param mmi Etape de calcul concernée
   */
  public static DIVIDE(mmi: MeasModeItem): void {

    const param1: MeasModeItem = mmi.c[0]; // valeurs
    const param2: MeasModeItem = mmi.c[1]; // diviseur

    const val: number = Number(param1.r);
    const divis: number = Number(param2.r);
    // console.log('divide', val, divis);

    // contrôle de cohérence
    if (!divis || !val || divis === 0) {
      mmi.r = '0';
    } else {
      mmi.r = (val / divis).toString();
    }
  }

  /**
   * calcule la distance entre 2 coordonnées GPS
   * @param mmi Etape de calcul concernée
   * @param 1 latitude coordonnée 1
   * @param 2 longitude coordonnée 1
   * @param 3 latitude coordonnée 2
   * @param 4 longitude coordonnée 2
   * @param 5 facultatif: unité de mesure : KM ou MI, défaut KM
   */
  public static GPSDIST(mmi: MeasModeItem): void {
    
    try {
      const lat1: number = Number(mmi.c[0].r); // latitude coordonnée 1
      const lon1: number = Number(mmi.c[1].r); // longitude coordonnée 1
  
      const lat2: number = Number(mmi.c[2].r); // latitude coordonnée 2
      const lon2: number = Number(mmi.c[3].r); // longitude coordonnée 2
      
      let unit: string = 'KM';
      if(mmi.c.length > 4) { // on a passé le paramètre unité
        unit = mmi.c[4].r;
      }

      let r: number = 6371; // rayon terre en kms
      if(unit === 'MI') { // mais si on veut des miles
        r = Math.round(r*(1000/1609.344));
      }

      // let result: number = Math.round(Math.acos(Math.sin(lat1)*Math.sin(lat2)+Math.cos(lat1)*Math.cos(lat2)*Math.cos(lon2-lon1))*xr);
      const p = Math.PI / 180;

      const a = 0.5 - Math.cos((lat2 - lat1) * p) / 2
                    + Math.cos(lat1 * p) * Math.cos(lat2 * p) *
                      (1 - Math.cos((lon2 - lon1) * p)) / 2;

      let result: number = 2 * r * Math.asin(Math.sqrt(a));
      
      if(isNaN(result)) {
        mmi.r = null;
      } else {
        mmi.r = result.toString();
      }
      
      // console.log("gps dist", mmi.r);
    } catch (e: any) {
      mmi.r = null;
      mmi.isErr = true;
    }
  }

}
